<script>
import conTracks from 'gkConUI/con-tracks'
import utils from '@/utils'
import { mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  components: {
    conTracks
  },
  computed: {
    ...mapState({
      config: 'config'
    })
  },
  updated () {
    utils.weixinshare({
      title: this.config.wechat_share.topics_title,
      imgUrl: this.config.wechat_share.default_logo,
      desc: this.config.wechat_share.default_desp
    })
  },
  mounted () {
    utils.weixinshare({
      title: this.config.wechat_share.topics_title,
      imgUrl: this.config.wechat_share.default_logo,
      desc: this.config.wechat_share.default_desp
    })
  },
  render () {
    return (<con-tracks/>)
  }
}
</script>
